import React, { Component } from "react";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import TopButton from "../../components/topButton/TopButton";
import SocialMedia from "../../components/socialMedia/SocialMedia";
import Button from "../../components/button/Button";
import ContactForm from "../../components/contactForm/ContactForm";
import { Fade } from "react-reveal";
import "./ContactComponent.css";
import { greeting, contactPageData } from "../../portfolio.js";

const ContactData = contactPageData.contactSection;
const addressSection = contactPageData.addressSection;
const emailSection = contactPageData.emailSection;

class Contact extends Component {
  render() {
    const theme = this.props.theme;
    return (
      <div className="contact-main">
        <Header theme={theme} />
        <div className="basic-contact">
          <Fade bottom duration={1000} distance="40px">
            <div className="contact-heading-div">
              <div className="contact-heading-img-div">
                <img
                  className="contact-portrait"
                  src={require(`../../assets/images/${ContactData["profile_image_path"]}`)}
                  alt="Vipul Tyagi"
                />
              </div>
              <div className="contact-heading-text-div">
                <h1
                  className="contact-heading-text"
                  style={{ color: theme.text }}
                >
                  {ContactData["title"]}
                </h1>
                <p
                  className="contact-header-detail-text subTitle"
                  style={{ color: theme.secondaryText }}
                >
                  {ContactData["description"]}
                </p>
                <SocialMedia theme={theme} />
                <div className="resume-btn-div">
                  <Button
                    text="See My Resume"
                    newTab={true}
                    href={greeting.resumeLink}
                    theme={theme}
                  />
                </div>
              </div>
            </div>
          </Fade>

          <Fade bottom duration={1000} distance="40px">
            <div className="contact-details-grid">
              <div className="contact-detail-card">
                <h3
                  className="contact-detail-label"
                  style={{ color: theme.text }}
                >
                  Location
                </h3>
                <p
                  className="contact-detail-value"
                  style={{ color: theme.secondaryText }}
                >
                  {addressSection["subtitle"]}
                </p>
              </div>
              <div className="contact-detail-card">
                <h3
                  className="contact-detail-label"
                  style={{ color: theme.text }}
                >
                  Email
                </h3>
                <p className="contact-detail-value">
                  <a
                    href={"mailto:" + emailSection["subtitle"]}
                    style={{ color: theme.secondaryText }}
                  >
                    {emailSection["subtitle"]}
                  </a>
                </p>
              </div>
            </div>
          </Fade>

          <Fade bottom duration={1000} distance="40px">
            <div className="contact-form-section">
              <h2
                className="contact-form-heading"
                style={{ color: theme.text }}
              >
                Send a Message
              </h2>
              <ContactForm theme={theme} />
            </div>
          </Fade>
        </div>
        <Footer theme={this.props.theme} onToggle={this.props.onToggle} />
        <TopButton theme={this.props.theme} />
      </div>
    );
  }
}

export default Contact;
